<template>
    <div class="img-content" ref="imgRef" :style="{ width, height, minWidth, minHeight }">
        <div v-if="isLoading || isError" class="img-loading" :style="{ 'border-radius': rounded }"></div>
        <div v-show="!isError" class="img">
            <img v-if="isInViewport" :src="src" :srcset="srcset" :sizes="sizes" loading="lazy" decoding="async"
                @error="onImgError" @load="onImgLoad" :style="{ 'object-fit': fit, 'border-radius': rounded }" />
        </div>
    </div>
</template>

<script setup>

const props = defineProps({
    src: String,
    width: [Number, String],
    minWidth: [Number, String],
    height: [Number, String],
    minHeight: [Number, String],
    fit: String,
    rounded: String,
    srcset: String, // 添加srcset支持
    sizes: String,  // 添加sizes支持
    alt: {         // 添加alt属性
        type: String,
        default: ''
    }
})
const imgRef = ref(null)
const isLoading = ref(false)
const isError = ref(false)
const isInViewport = ref(false);  // 新增：判断元素是否在视口内

// 使用 IntersectionObserver 来判断元素是否出现在视口内
onMounted(() => {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // console.log(entry.isIntersecting)
                    isInViewport.value = true;
                    isLoading.value = true
                    observer.unobserve(entry.target); // 只需要触发一次
                }
            });
        },
        {
            rootMargin: '50px 0px',
            threshold: 0.01,  // 视口进入 10% 时触发
        }
    );
    if (imgRef.value) {
        observer.observe(imgRef.value);
    }
    // 组件销毁时清理
    onUnmounted(() => {
        observer.disconnect();
    });
});

// 图片加载完成
function onImgLoad() {
    isLoading.value = false;
}
// 图片加载失败
function onImgError() {
    isLoading.value = false;
    isError.value = true;  // 设置加载失败标志
}
</script>

<style lang="scss" scoped>
.img-content {
    position: relative;
    width: inherit;
    height: inherit;

    .img-loading {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #1e1f22;
        animation: 0.8s linear 0s infinite alternate none running animation-loading;
    }

    .img {
        width: inherit;
        height: inherit;

        img {
            width: inherit;
            height: inherit;
            user-select: none;
            pointer-events: none;
            will-change: transform; // 优化动画性能
            backface-visibility: hidden; // 防止闪烁
        }
    }



}

@keyframes animation-loading {
    0% {
        background-color: #090a0d;
    }

    100% {
        background-color: #1e1f22;
    }
}
</style>